import { Form, Toast, ToastBody, ToastHeader } from "reactstrap";
import { TripModal } from "../../../Components/Common/TripModal/tripModal";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getAllVehicleList,
  getAllDriverList,
  createTripsUsingExcel,
  getAllTripsList,
} from "../../../slices/thunks";
import { hideErrorMessage } from "../../../slices/tripsDetails/reducer";

export const UploadTripModal = ({
  addTripModal,
  toggleAddTripModal,
  loading,
  pageSize,
  currentPage,
  searchText,
  selectedItem,
}) => {
  const formikRef = useRef(null);
  const dispatch = useDispatch();
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toasterType, setToasterType] = useState("success");
  const [toastMessage, setToastMessage] = useState("");
  const showToaster = (isSuccess, message) => {
    setShowToast(true);
    setToasterType(isSuccess ? "success" : "danger");
    setToastMessage(message);
    setTimeout(() => {
      setShowToast(false);
      toggleAddTripModal();
      setSelectedFile(null);
      setFileName("");
      getAllTripsList(
        currentPage,
        pageSize,
        searchText,
        selectedItem.toLowerCase(),
        "",
        ""
      );
      if (!isSuccess) {
        dispatch(hideErrorMessage());
      }
    }, 3000);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file);

    if (file) {
      setSelectedFile(file);
      setFileName(file.name);
    }
  };

  const handleTripsSubmit = async (values) => {
    try {
      let response;
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        response = await dispatch(createTripsUsingExcel(formData));
      }
      const { success: isSuccess, message } = response;
      showToaster(isSuccess, message);
    } catch (error) {
      console.log(error, "error");

      showToaster(false, error.message || "An unexpected error occurred");
    }
  };

  useEffect(() => {
    try {
      dispatch(getAllDriverList("None", "None", ""));
      dispatch(getAllVehicleList("None", "None", ""));
    } catch (error) {}
  }, [dispatch]);

  return (
    <TripModal
      isModalOpen={addTripModal}
      toggleModal={toggleAddTripModal}
      buttonText={"Add"}
      closeText={"Close without saving"}
      title={"Add trip"}
      tripText={"Upload Trip Excel File"}
      showcloseIcon={true}
      size="lg"
      loading={loading}
      onSubmit={() => {
        if (formikRef.current) {
          formikRef.current.handleSubmit();
        }
      }}
    >
      <Formik
        innerRef={formikRef}
        initialValues={{}}
        onSubmit={handleTripsSubmit}
      >
        {() => (
          <Form className="px-3 py-2 py-sm-0 d-flex flex-column gap-4">
            <div
              className="position-fixed top-0 end-0 p-3"
              style={{ zIndex: 1055 }}
            >
              <Toast isOpen={showToast}>
                <ToastHeader
                  icon={toasterType === "danger" ? "danger" : "success"}
                  toggle={() => setShowToast(false)}
                >
                  {toasterType === "danger" ? "Error" : "Success"}
                </ToastHeader>
                <ToastBody>{toastMessage}</ToastBody>
              </Toast>
            </div>

            <div className="upload-container">
              <p className="upload-heading">
                Choose a file or drag & drop it here
              </p>
              <p className="upload-subtext">Supported file types: .xlsx</p>
              <label htmlFor="file-upload" className="upload-btn">
                Browse File
              </label>
              <input
                id="file-upload"
                type="file"
                accept=".jpeg,.jpg,.png,.pdf,.mp4,.xls,.xlsx"
                hidden
                onChange={handleFileChange}
              />
              {fileName && (
                <p className="file-name">Selected file: {fileName}</p>
              )}
            </div>

            {loading && (
              <p
                className="text-center"
                style={{ color: "green", fontSize: "20px" }}
              >
                Your file is being uploaded. Please wait a moment.
              </p>
            )}
          </Form>
        )}
      </Formik>
    </TripModal>
  );
};
